export default __webpack_public_path__ + "static/d3l2-crab-spotify-4b10beddf663dc475e4772b751835b91.png";